// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__142r9","Page__back":"Page_Page__back__2LkcO","Page__title":"Page_Page__title__3m8qD","Page__spinner":"Page_Page__spinner__3VnIN","spin":"Page_spin__qXGvy"};